export default "__VITE_ASSET__CFWOQhd8__"